export type PersonalPlanBillingCopyKey =
    | 'cancel_anytime'
    | 'monthly_or_annual'
    | 'yearly'
    | 'monthly';

interface RenewalInterval {
    count?: number;
}

interface PersonalPlanBillingInput {
    isAnnualPlanEnabled?: boolean;
    monthlyPlanOption?: {
        renewalInterval?: RenewalInterval;
    } | null;
}

/** True when the plan uses a 3-month (quarterly) renewal interval. */
export function isThreeMonthRenewalInterval(renewalInterval?: RenewalInterval | null): boolean {
    return renewalInterval?.count === 3;
}

/**
 * FAQ uses generic (non-monthly) copy only when annual is enabled by itself,
 * or when annual is enabled together with a 3-month plan. All other offers use monthly copy.
 */
export function shouldShowMonthlyPlanFaqCopy(plan?: PersonalPlanBillingInput): boolean {
    if (!plan?.isAnnualPlanEnabled) {
        return true;
    }

    const isThreeMonthPlan = isThreeMonthRenewalInterval(plan.monthlyPlanOption?.renewalInterval);
    return Boolean(plan.monthlyPlanOption) && !isThreeMonthPlan;
}

/** Resolves which billing subtitle copy to show for a Personal Plan offer. */
export function getPersonalPlanBillingCopyKey(
    plan?: PersonalPlanBillingInput,
): PersonalPlanBillingCopyKey | null {
    if (isThreeMonthRenewalInterval(plan?.monthlyPlanOption?.renewalInterval)) {
        return 'cancel_anytime';
    }
    if (plan?.isAnnualPlanEnabled && plan?.monthlyPlanOption) {
        return 'monthly_or_annual';
    }
    if (plan?.isAnnualPlanEnabled) {
        return 'yearly';
    }
    if (plan?.monthlyPlanOption) {
        return 'monthly';
    }
    return null;
}
